module.exports = __webpack_public_path__ + "static/media/nonkululeko_dlamini.e7e3bdea.JPG";